import React from 'react';
import { elementType, func, node, oneOfType, string } from 'prop-types';
import { isArray } from 'lodash';
import Stepper from '..';

const Step = ({ children, stepId }) => {
    const stepperContext = Stepper.useContext();
    const { currentStepId } = stepperContext;

    const enrichedChildren = React.useMemo(() => {
        const childIsComponent = (child) => child.type && typeof child.type === 'function';

        const cloneChild = (child) => {
            if (childIsComponent(child) && React.isValidElement(child)) {
                return React.cloneElement(child, { ...stepperContext, stepId });
            }

            return child;
        };

        if (typeof children === 'function') {
            return children({ ...stepperContext, stepId });
        }

        if (isArray(children)) {
            return React.Children.map(children, cloneChild);
        }

        if (childIsComponent(children)) {
            return cloneChild(children);
        }

        return children;
    }, [children, stepId, stepperContext]);

    if (currentStepId !== stepId) {
        return null;
    }

    return (
        <>
            {enrichedChildren}
        </>
    );
};

Step.propTypes = {
    children: oneOfType([node, elementType, func]),
    stepId: string.isRequired
};

export default Step;
